export const companyFieldConfiguration = [
  {
    name: "name",
    label: "Company name",
    type: "text",
    validation: {
      required: "Company Name is required",
      minLength: { value: 1, message: "Minimum length is 1 characters" },
      maxLength: { value: 200, message: "Maximum length is 200 characters" },
    },
  },
  {
    name: "managerName",
    label: "Manager Name",
    type: "text",
  },
  {
    name: "managerPhoneNumber",
    label: "Manager Phone Number",
    type: "text",
  },
  {
    name: "billingContactName",
    label: "Billing Contact Name",
    type: "text",
  },
  {
    name: "billingEmailAddress",
    label: "Billing Email",
    type: "text",
  },
  {
    name: "defaultPaymentMethod",
    label: "Default Payment Method",
    type: "select",
    options: [
      { value: "Statements", label: "Statements" },
      { value: "ACH", label: "ACH" },
      { value: "Zelle", label: "Zelle" },
      { value: "Cash", label: "Cash" },
      { value: "QuickBook Payment", label: "QuickBook Payment" },
    ],
  },
  {
    name: "billingContactPhoneNumber",
    label: "Billing Contact Phone Number",
    type: "text",
  },
  {
    name: "taxId",
    label: "Tax Id",
    type: "text",
  },
  {
    name: "dotNumber",
    label: "DOT Number",
    type: "text",
  },
  {
    name: "mcNumber",
    label: "MC Number",
    type: "text",
  },
  {
    name: "addressLine1",
    label: "Address Line 1",
    type: "text",
  },
  {
    name: "addressLine2",
    label: "Address Line 2",
    type: "text",
  },
  {
    name: "city",
    label: "City",
    type: "text",
  },
  {
    name: "state",
    label: "State",
    type: "text",
  },
  {
    name: "zipCode",
    label: "Zip Code",
    type: "text",
  },
];

export const companyInitialValues = {
  name: "",
  managerName: "",
  managerPhoneNumber: "",
  billingContactName: "",
  billingContactPhoneNumber: "",
  billingEmailAddress: "",
  defaultPaymentMethod: "",
  taxId: "",
  dotNumber: "",
  mcNumber: "",
  addressLine1: "",
  addressLine2: "",
  city: "",
  state: "",
  zipCode: "",
};
